module.exports = __webpack_public_path__ + "img/menuicon-108-active.eb04c032.png";